import PackageDetail from "./packageDetails.container";

export default PackageDetail;
